var _g, _g2, _path, _path2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 524.67004,
    height: 458.46641,
    viewBox: "0 0 524.67004 458.46641",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "366.92509 451.64652 358.96824 451.64574 355.18311 420.95467 366.92669 420.9555 366.92509 451.64652",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66391,451.46602h0c-.24775,.41726-.37847,1.76397-.37847,2.2492h0c0,1.49148,1.20906,2.70059,2.70059,2.70059h24.64145c1.01748,0,1.84235-.82483,1.84235-1.84235v-1.0259s1.21899-3.08337-1.29069-6.88379c0,0-3.1192,2.97579-7.78008-1.6851l-1.37445-2.48993-9.94915,7.27631-5.51466,.6788c-1.2065,.14849-2.27617-.02305-2.89677,1.02217h-.0001Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "450.92097 441.69286 443.64997 444.92459 427.72316 418.41788 438.45435 413.64786 450.92097 441.69286",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.93735,452.60265h0c-.05688,.48192,.37077,1.7656,.56789,2.20899h0c.60591,1.36286,2.2019,1.97652,3.5648,1.3706l22.51647-10.01047c.92973-.41335,1.34839-1.50214,.93503-2.43192l-.41677-.93743s-.13874-3.31268-3.9759-5.76582c0,0-1.64131,3.98633-7.79372,1.62084l-2.26745-1.71684-6.13521,10.69062-4.76334,2.86057c-1.04213,.62582-2.08924,.90362-2.23171,2.11083l-.00009,.00004Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "349.63242 259.6055 342.55798 274.46181 354.58452 428.68442 369.62465 428.68442 375.80781 327.52005 429.78517 428.68442 448.23439 428.68442 420.37673 356.52521 401.27577 262.43528 349.63242 259.6055",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5115,164.33088h-18.65447l-6.84156,10.73517-15.43181,7.38043,3.35474,46.29542-1.68299,33.75529,2.3061-.06729c16.46312-.48041,32.91858,2.19746,48.1967,8.34923,3.91962,1.57824,8.02835,2.45869,11.56551,1.5744,0,0-1.3419-5.36758-2.68379-6.70948s-2.01284-2.45134-1.3419-3.23851,2.01284-1.45812,.67095-2.80002-1.3419-3.03247-1.3419-3.03247l-4.02569-29.84398,8.05138-42.26973-16.7737-9.39327-5.36758-10.73517Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.56742 222.85848 419.05892 262.45207 409.20728 297.74739 401.33194 294.80974 404.8286 262.458 404.36895 218.67767 419.56742 222.85848",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.7173,
    cy: 302.44532,
    rx: 9.34055,
    ry: 5.54595,
    transform: "translate(33.84638 645.456) rotate(-79.68097)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6271,182.44648s11.11555,1.72228,11.26083,11.26083,10.88045,24.97036,4.17097,37.04743l-17.44465,2.68379-9.39327-34.21835,10.73517-18.1156",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.89126 215.88554 332.73963 248.70651 305.13579 272.8072 300.16406 266.02983 320.8399 240.90273 344.47961 204.05042 354.89126 215.88554",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.96827,
    cy: 273.72207,
    rx: 9.34055,
    ry: 5.54595,
    transform: "translate(-105.73809 300.74123) rotate(-46.40043)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41289,174.45177s8.34745,7.53935,3.23473,15.59324-4.60622,26.8456-16.84246,33.26019l-16.05633-7.32893c1.35263-13.2314,2.1416-26.9498,10.9242-33.76076l18.9153-9.25374",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 375.28975,
    cy: 144.87397,
    r: 16.69164,
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.54887,158.58853c.91941,.15676,1.99877-2.07178,3.03018-4.24226,2.15919-4.54357,3.53176-7.43194,3.63622-11.51469,.08903-3.47968-.87769-2.56641-1.81811-10.30262-.31016-2.55161-4.66937-2.5467-5.5566-3.75833-1.49867-2.04663,.80075-2.89069-2.92791-4.12015-6.98407-2.30282-10.14225,1.27453-14.57763,1.58272-.11208,.0078-2.31088,2.15811-3.5389,2.2693-2.15151,.19481-5.25531-.14031-6.64679-3.41835-1.30105-3.06501-2.16288,5.89157-1,7,.98732,.94109,2.69047,3.3032,2.73393,3.47498,.0492,.19442-4.0497-4.34613-4.73393-2.47498-.49244,1.34664,1.05766,8.27494,2.30979,8.53535,1.0471,.21772,3.60797-3.23361,3.03018-1.81811-1.33997,3.28276,6.7173,5.37739,16.36299-1.21207,.34204-.2337,.01894,.13901,1.21207,3.03018,1.50477,3.64643,1.84437,3.84395,1.81811,4.84829-.05685,2.1741-1.68924,2.81424-1.21207,4.24226,.38647,1.15659,1.89675,2.05196,3.03018,1.81811,1.27902-.26396,1.4983-1.84622,2.42415-1.81811,.79306,.02412,1.73425,1.21858,1.81811,2.42415,.17663,2.53978-3.58336,3.23829-4.24226,6.6664-.37186,1.9347,4.00338-1.35611,4.84829-1.21207Z",
    fill: "#2f2e41"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.41218,457.17619H111.98738c-21.51191,0-39.01333-17.50142-39.01333-39.01374V39.01333C72.97405,17.50142,90.47547,0,111.98738,0H255.41218c21.51151,0,39.01291,17.50142,39.01291,39.01333,2.6698,152.25461,7.2226,322.75577,0,379.14914,0,21.51233-17.5014,39.01372-39.01291,39.01372Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.42527,139.4635c-.91025,0-1.65045,.74021-1.65045,1.65045v52.81453c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-52.81453c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71194,39.01362V418.15594c0,18.7244-14.57349,34.04062-33.00082,35.22894h-.00826c-.27234,.01652-.54463,.03304-.82523,.0413-.48691,.02473-.97376,.03299-1.46888,.03299,0,0-1.81551-.13206-5.13294-.37962-3.35042-.24756-8.22749-.61892-14.30946-1.10578-1.82372-.14032-3.74651-.29712-5.77659-.46213-4.04358-.33011-8.48331-.69321-13.24488-1.10583-1.89801-.1568-3.86206-.33006-5.86735-.50338-10.24931-.883-21.72824-1.91453-33.83431-3.08634-2.04655-.18984-4.10961-.38788-6.1892-.59419-.54463-.05777-94.3661-23.64272-94.3661-28.06598V39.01362c0-19.50007,15.80312-35.30319,35.30324-35.30319h21.07628c3.36694,0,6.07366,2.62422,6.36252,5.9829,.02473,.22283,.04951,.4456,.09076,.66843,.61066,3.3752,3.70526,5.72708,7.13818,5.72708h74.08205c3.43292,0,6.52752-2.35188,7.13818-5.72708,.04125-.22283,.06603-.4456,.09081-.66843,.28881-3.35868,2.99553-5.9829,6.36247-5.9829h21.07633c19.50007,0,35.30319,15.80312,35.30319,35.30319Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.14898,99.8526c-.91025,0-1.65045,.74021-1.65045,1.65045v13.20363c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-13.20363c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.14898,139.4635c-.91025,0-1.65045,.74021-1.65045,1.65045v25.58204c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-25.58204c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.14898,175.77349c-.91025,0-1.65045,.74021-1.65045,1.65045v25.58204c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-25.58204c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.61931,
    y: 9.49024,
    width: 32.18385,
    height: 4.12614,
    rx: 0.31021,
    ry: 0.31021,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.54767,
    cy: 10.31547,
    r: 3.30091,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.62517,
    cy: 10.31547,
    r: 3.30091,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.70266,
    cy: 10.31547,
    r: 3.30091,
    fill: "#e6e6e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.75225,303.72529c0-37.62527-31.80087-58.32329-68.12658-68.12658-46.57288-12.5687-80.6821,12.86459-68.12659,68.12659,8.336,36.69019,50.64836,91.44583,68.12659,58.12657,20-38.12658,68.12658-20.50131,68.12658-58.12658Z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,457.27641c0,.66003,.53003,1.19,1.19006,1.19H523.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#ccc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M167.21108,297.00903l-8.22992-3.89856c3.37555,4.71082,6.28418,12.06805,7.84137,17.92249,2.63654-5.45343,6.88672-12.1261,11.09375-16.11194l-8.69812,2.23767c5.35974-26.26794,25.5191-45.12573,48.60437-45.12573l.32679-.9488c-24.11316,0-45.46577,18.59639-50.93824,45.92488Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.0903,337.03299h-52c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h52c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z",
    fill: "#6c63ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.69993,129.72529v106c0,9.37402-7.62598,17-17,17h-106c-9.37402,0-17-7.62598-17-17v-106c0-9.37402,7.62598-17,17-17h106c9.37402,0,17,7.62598,17,17Zm-17,121c8.28427,0,15-6.71573,15-15v-53.44094c0-37.31184-30.24722-67.55906-67.55906-67.55906h-53.44094c-8.28427,0-15,6.71573-15,15v106c0,8.28427,6.71573,15,15,15h106Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.8104,156.01748h-34.22061c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.56471-1.56439,1.56471Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8104,189.3811h-34.22061c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.56471-1.56439,1.56471Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8104,235.3811h-34.22061c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.56471-1.56439,1.56471Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17354,172.71023h-70.94689c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h70.94689c.86273,0,1.56439,.70166,1.56439,1.56439,0,.86273-.70166,1.56471-1.56439,1.56471Z",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMen);
export default __webpack_public_path__ + "static/media/phone-men.977bf389a4d4dcb865aee84f1ec340ef.svg";
export { ForwardRef as ReactComponent };